module.exports = __webpack_public_path__ + "img/17.53a25576.jpg";